/** Tailwind `sm` — block UI below 640px; sm (640px) and up are supported. */
export const MOBILE_MIN_SUPPORTED_WIDTH_PX = 640;

export function getViewportWidth() {
  if (typeof window === "undefined") return null;
  const width = window.innerWidth || document.documentElement.clientWidth;
  return width > 0 ? width : null;
}

export function isMobileViewport() {
  const width = getViewportWidth();
  if (width == null) return false;
  return width < MOBILE_MIN_SUPPORTED_WIDTH_PX;
}
